export const VIEW_NAMES = {
  MAIN_VIEW_NAME: 'main',
  MODAL_VIEW_NAME: 'modal',
}

export const UCS_TOAST_MESSAGE_EVENT_IDS = {
  ENROLLMENT_SUCCESS: 'enrollmentSuccess',
}

export const WHITELISTED_MANAGE_CARD_TOAST_MESSAGE_EVENT_IDS = [
  UCS_TOAST_MESSAGE_EVENT_IDS.ENROLLMENT_SUCCESS,
]

export const ACCOUNT_TYPES = {
  BUSINESS: 'BUSINESS',
  PREMIER: 'PREMIER',
  PERSONAL: 'PERSONAL',
}

export const EU_COUNTRIES = ['DE', 'AT', 'FR', 'IT', 'ES', 'IE', 'BE', 'FI', 'NL', 'PT', 'GB']
